module.exports = __webpack_public_path__ + "static/media/chan.35042a6e.jpg";